import { render, staticRenderFns } from "./LegendPlugin.vue?vue&type=template&id=4e817884&scoped=true"
import script from "./LegendPlugin.vue?vue&type=script&lang=ts"
export * from "./LegendPlugin.vue?vue&type=script&lang=ts"
import style0 from "./LegendPlugin.vue?vue&type=style&index=0&id=4e817884&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e817884",
  null
  
)

export default component.exports